// 地址监控页面翻译
export default {
  // 输入框占位符
  placeholders: {
    monitorName: "请输入监控名称",
    monitorAddress: "请输入监控地址",
    selectCurrency: "请选择币种",
  },

  // 按钮
  buttons: {
    reset: "重置",
    search: "查询",
    addMonitor: "+ 添加监控",
    view: "查看",
    edit: "修改",
  },

  // 标题和统计
  statistics: {
    totalMonitors: "条地址监控",
    monitoring: "监控中",
    total: "共",
    count: "条",
  },

  // 监控类型
  monitorTypes: {
    common: "普通监控",
    realtime: "实时监控",
  },

  // 监控状态
  status: {
    enable: "监控中",
    pause: "已暂停",
  },

  // 监控信息
  monitorInfo: {
    monitorName: "监控名称",
    address: "地址",
    relatedCase: "关联案件",
    condition: "条件",
    remark: "备注",
    dynamics: "条监控动态",
    unread: "条未读",
  },

  // 对话框
  dialogs: {
    title: "提示",
    addMonitor: "添加监控",
    edit: "修改",
    deleteConfirm: "此操作将永久删除该文件, 是否继续?",
    changeStatusConfirm: "是否变更状态为",
    openMonitor: "打开监控",
    closeMonitor: "关闭监控",
    dingTalkHelp: "钉钉添加机器人操作说明",
  },

  // 详情抽屉
  details: {
    title: "详情",
    transferIn: "转入",
    transferOut: "转出",
    amount: "金额",
    address: "地址",
    hash: "hash",
    time: "时间",
  },

  // 提示信息
  messages: {
    noData: "暂无数据",
    deleteSuccess: "删除监控成功",
    deleteCancelled: "已取消删除",
    editSuccess: "修改成功",
    closeSuccess: "关闭监控成功",
    copySuccess: "复制成功",
    loading: "拼命加载中",
  },

  // 确认按钮
  confirm: {
    yes: "是",
    no: "否",
    ok: "确定",
    cancel: "取消",
  },
};
